import React from 'react';
import { getTimeByOpMode } from '../../../../pages/PlanOperationPage/util/function_operation/constants';
import { selectOpMode } from '../../../../util/store/selectors';
import { useSelector } from '../../../../util/store/store';
import { OP_STATUS, operationType } from "../../../../util/varibles/constants";
import { getLink, LINK_ID, onOpenPage } from "../../../../util/varibles/global";
import { IEvent2, IPropsChildren, TOperation2 } from "../../../../util/varibles/interface";
import Icon from "../../../Icon";
import WeatherChart from "../../../WeatherChart";
import Certain from "../_component/Certain";
import { getPopupOpInfo, usePopupOpInfo } from '../PopupOpInfoContext';
import styles from "./style.module.scss";

const WeatherSection = () => {
    const [activity_log = []] = usePopupOpInfo(state => state.data?.activity_log);
    const [weather] = usePopupOpInfo(state => state.weather);

    const opMode = useSelector(selectOpMode);

    const startTime = getTimeByOpMode[opMode](activity_log[0]);
    const finishTime = getTimeByOpMode[opMode](activity_log[activity_log.length - 1]);
    const keyWeather = `${startTime}|${finishTime}`;

    return <WeatherChart {...{ keyWeather, loading: weather.loading, weather: weather.data, minInterval: 10800000 }} />
}

interface IProps extends IPropsChildren {
    operation: TOperation2
}

const Header: React.FC<IProps> = (props) => {
    const { operation } = props;
    const { tenant_name, status, operation_type, id, tenant_id } = operation;
    const link = getLink[LINK_ID.OP_DETAIL]([tenant_id, id])

    const { icon } = operationType[operation_type];
    const { isOwn, onClose } = getPopupOpInfo()();

    return <>
        <div className={[styles['popup-header'], 'flex justify-center mb-2'].join(' ')}>
            <div className='w-full no-select flex align-items-center mt-[3px]'>
                <div className={styles.infoId}>
                    <Icon icon={icon!} dataAttribute={{ 'data-event-type': (operation as IEvent2).event_type }} />
                    {status !== OP_STATUS.NEW ? <div onMouseDown={e => onOpenPage(e, link, onClose)}>
                        #{operation.operation_code}
                    </div> : <span>#{operation.operation_code}</span>}
                </div>
                {props.children}
            </div>
            <div className='flex align-items-center'>
                {!isOwn && <div className={styles['spot']}>({tenant_name}) <div /></div>}
                <div className='mt-[1px]'>
                    <Certain operation={operation} status={status} />
                </div>
                <div className='bt-close' onMouseDown={onClose} />
            </div>
        </div>
        <WeatherSection />
    </>;
};

export default Header;
